import React from "react";
import { useWebSocket } from "../../context/WebSocketContext";
import "./ConnectionStatusBar.css";

const ConnectionStatusBar = () => {
    const { statusMessage } = useWebSocket();

    if (!statusMessage) return null;

    const className = `connection-status-bar ${statusMessage
        .toLowerCase()
        .replace(/\s+/g, "-")}`;

    return <div className={className}>{statusMessage}</div>;
};

export default ConnectionStatusBar;
